import "./artworks.css";

import React from "react";
import { Link } from "react-router-dom";

import { artworkPath } from "../../data/content";
import { artworkImage } from "../../data/gallery";

//Photo, name and price, linking to the artwork's page
const ArtworkCard = ({ artwork, showPrice = true }) => {
  return (
    <Link
      to={artworkPath(artwork.slug)}
      className={"artwork-card"}
    >
      <span className={"artwork-card-photo"}>
        <img
          src={artworkImage(artwork.images[0], true)}
          alt={""}
          loading={"lazy"}
          decoding={"async"}
          width={520}
          height={520}
        />
      </span>
      <span className={"artwork-card-name"}>{artwork.name}</span>
      {showPrice ? <span className={"artwork-card-price"}>{artwork.price}</span> : null}
    </Link>
  );
};

export default ArtworkCard;
